const CircularProgress = {
  parts: ["root", "icon"],
  baseStyle: {
    root: {
      display: "inline-block",
      position: "relative",
      verticalAlign: "middle",
      fontFamily: "body"
    },
    icon: {
      display: "block",
      color: "blue.500"
    }
  },
  sizes: {
    sm: {
      root: { fontSize: "1.5rem" },
      icon: { height: "1.5rem", width: "1.5rem", strokeWidth: "0.125rem" }
    },
    md: {
      root: { fontSize: "3rem" },
      icon: { height: "3rem", width: "3rem", strokeWidth: "0.25rem" }
    },
    lg: {
      root: { fontSize: "4rem" },
      icon: { height: "4rem", width: "4rem", strokeWidth: "0.34375rem" }
    }
  }
};

export { CircularProgress };
